export default {
  id: 137,
  title: 'Target #137 - Elbow',
  url: 'https://cssbattle.dev/play/137',
  colors: ['#6592CF', '#060F55'],
  solution:
    '<a><style>body{background:#6592cf}a{width:250;height:150;position:fixed;border:0 solid #060f55;top:50;left:50;border-width:50px 0 0 50px;border-radius:100px 0 0}</style>',
}
